/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer - IBL
 * @Email : kpozos@ibl.mx
 *
 */
import CustomTooltip from "../../CustomTooltip";
import {
    EmailSubsectionChip,
    PersonChip,
    PhoneSubsectionChip,
    PlusIconsOptions
} from "../../buttons/IconButtons";
import CustomCard from "../../CustomCard";

/**
 * Card component used to display user information (full name, email, phone)
 * and allow adding the item to a selected list.
 *
 * @param {Object} props - Component properties
 * @param {Object} props.item - Item data to display
 * @param {string} props.item.fullName - User full name
 * @param {string} props.item.email - User email address
 * @param {string} [props.item.phoneNumber] - User phone number (optional)
 * @param {boolean} props.item.disabled - Indicates if the item is disabled (prevents interaction)
 * @param {Function} props.onAdd - Callback executed when the add action is triggered
 *
 * @returns {JSX.Element} User card component with add functionality
 */
const UserEmailPhoneCard = (
    {
        item,
        onAdd
    }
) => {

    return (
        <>
            <CustomCard
                classes="w-100"
                classCard="card-border-8px"
                classContent={`background-shades-50 ${item?.disabled ? 'disable-card-item' : 'background-hover-shades-100' }`}
            >
                <div className="row align-items-center">
                    <div className={`col-10`}>
                        <div className="d-flex align-items-center justify-content-between">
                            <div><PersonChip className="mr-8px mb-1" /></div>
                            <div className={`flex-grow-1 minw-0`}>
                                <CustomTooltip
                                    text={item?.fullName}
                                    classes={`fs-14px font-color-general-950 ibl-font-w-600 text-ellipsis-1-row `}
                                    showIfTruncated={true}
                                />
                            </div>
                        </div>

                        <div className="border-bottom-shades-300 my-2" />
                        <div className='row align-items-center justify-content-between '>
                            <div className={`${item?.phoneNumber ? 'col-6' : 'col-12'} pl-0`}>
                                <div className="d-flex align-items-center">
                                    <div><EmailSubsectionChip className="mr-8px mb-1" /></div>
                                    <div className={"flex-grow-1 minw-0"}>
                                        <CustomTooltip
                                            text={item?.email}
                                            classes={`fs-14px font-color-general-950 text-ellipsis-1-row`}
                                            showIfTruncated={true}
                                        />
                                    </div>
                                </div>
                            </div>
                            {item?.phoneNumber &&
                                <div className='col-6 px-0'>
                                    <div className="d-flex align-items-center">
                                        <div><PhoneSubsectionChip className="mr-8px mb-1" /></div>
                                        <div className={"flex-grow-1 minw-0"}>
                                            <CustomTooltip
                                                text={item?.phoneNumber}
                                                classes={`fs-14px font-color-general-950 text-ellipsis-1-row`}
                                                showIfTruncated={true}
                                            />
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                    <div className='col-2 pr-1'>
                        <div className={"d-flex justify-content-end"}>
                            <div>
                                <PlusIconsOptions
                                    className={`plus-icons-options icon-color-shades-400`}
                                    onClick={() => onAdd(item)}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </CustomCard>
        </>
    );

}
export default UserEmailPhoneCard
